import { Component, ReactNode } from 'react';
import { Alert, Button, Container } from 'react-bootstrap';

interface RouteErrorBoundaryProps {
    children: ReactNode;
}

interface RouteErrorBoundaryState {
    hasError: boolean;
}

export class RouteErrorBoundary extends Component<RouteErrorBoundaryProps, RouteErrorBoundaryState> {
    state: RouteErrorBoundaryState = { hasError: false };

    static getDerivedStateFromError(): RouteErrorBoundaryState {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
                    <Alert variant="danger" className="text-center">
                        <h2 className="alert-heading">Unable to load this page</h2>
                        <p>The application may have been updated. Reload to continue.</p>
                        <Button variant="primary" onClick={() => window.location.reload()}>
                            Reload Application
                        </Button>
                    </Alert>
                </Container>
            );
        }

        return this.props.children;
    }
}
